export default "__VITE_ASSET__BuYk2f46__"